<template>
    <div class="dashboard-wrap">
        <h1 class="dashboard-title">
            <span>Оплата услуг</span>
            <router-link to="/dashboard/payment-services/259" class="button md-block">Вывод на карту</router-link>
        </h1>
        <div class="dashboard-list">
            <div class="row">
                <router-link v-for="item in getServiceList" :key="item" :to="'/dashboard/payment-services/' + item.id" class="col-6 col-md-4 col-lg-3 col-xl-3 payment-service-wrap">
                    <div class="list-item">
                        <img :src="item.logo ? item.logo : PaymentIcon" :alt="item.name">
                        <div class="list-item-wrap">
                            <div>
                                <span class="text-white active">{{ item.name }}</span>
                            </div>
                            <a class="list-item-button text">{{ item.total }} Услуг</a>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import PaymentIcon from '../../assets/img/icons/box.svg'

export default {
    data() {
        return {
            PaymentIcon: PaymentIcon,
            searchValue: '',
        }
    },
    mounted() {
        this.$store.dispatch('getPaymentServices')
    },
    computed: {
        getServiceList() {
            return this.$store.getters.getPaymentServices
        }
    },
    methods: {
        search(item) {
            return (item.name.toLowerCase().search(this.searchValue.toLowerCase()) !== -1 || item.currency.toLowerCase().search(this.searchValue.toLowerCase()) !== -1) ? true : false
        }
    }
}
</script>